import { useStore } from '@/store';

export default (to: any, from: any, next: Function) => {
  useStore().setMenuOverride(null);
  next();
};
